export interface ValidatorItem {
    required?: boolean | ((data: any) => boolean);
    email?: boolean;
    phone?: boolean;
    date?: boolean;
    number?: boolean;
    min?: number;
    max?: number;
    maxLength?: number;
    minLength?: number;
}

export interface ValidatorInput {
    [field_name: string]: ValidatorItem;
}

export interface ValidationResult {
    isValid: boolean;
    errors: Record<string, string | null>;
}

export type ValidatorFunc = (rules: ValidatorItem, value: any) => string | null;

const EmailValidator: ValidatorFunc = (rules: ValidatorItem, value: any) => {
    if (!rules.email) return null;
    const valid = /^\S+@\S+\.\S+$/.test(value);
    if (!valid) return "Ongeldig e-mailadres";
    return null;
}

const NumberValidator = (rules: ValidatorItem, value: any) => {
    if (!rules.number) return null;
    if (isNaN(value)) return "Dit veld moet een nummer zijn";
    return null;
}

const DateValidator: ValidatorFunc = (rules: ValidatorItem, value: any) => {
    if (!rules.date) return null;
    const valid = !isNaN(Date.parse(value));
    if (!valid) return "Ongeldige datum";
    return null;
}

const PhoneValidator: ValidatorFunc = (rules: ValidatorItem, value: any) => {
    if (!rules.phone) return null;
    const valid = /^\+?[0-9\s\-()]+$/.test(value);
    if (!valid) return "Ongeldig telefoonnummer";
    return null;
}

const MinValidator: ValidatorFunc = (rules: ValidatorItem, value: any) => {
    if (!rules.min || !rules.number) return null;
    if (isNaN(value) || Number(value) < rules.min) return `Waarde moet minimaal ${rules.min} zijn`;
    return null;
}

const MaxValidator: ValidatorFunc = (rules: ValidatorItem, value: any) => {
    if (!rules.max || !rules.number) return null;
    if (isNaN(value) || Number(value) > rules.max) return `Waarde mag maximaal ${rules.max} zijn`;
    return null;
}

const LengthValidator: ValidatorFunc = (rules: ValidatorItem, value: any) => {
    if (!rules.minLength && !rules.maxLength) return null;
    if (rules.minLength && value.length < rules.minLength) {
        return `Waarde moet minimaal ${rules.minLength} tekens zijn`;
    }
    if (rules.maxLength && value.length > rules.maxLength) {
        return `Waarde mag maximaal ${rules.maxLength} tekens zijn`;
    }
    return null;
}


export class Validator {
    private rules: ValidatorFunc[] = [];

    constructor(private config: ValidatorInput) {
        this.rules = [
            EmailValidator,
            NumberValidator,
            DateValidator,
            PhoneValidator,
            MinValidator,
            MaxValidator,
            LengthValidator,
        ]
    }

    public validate(data: any): ValidationResult {
        const errors: Record<string, string | null> = {};
        let isValid = true;

        for (const [field, rules] of Object.entries(this.config)) {
            const value = data[field];
            // required
            if (typeof rules.required === 'function' ? rules.required(data) : rules.required && (!value || (Array.isArray(value) && value.length === 0))) {
                errors[field] = "Dit veld is verplicht";
                isValid = false;
                continue;
            }
            for (const ruleFn of this.rules) {
                const error = ruleFn(rules, value);
                if (error) {
                    errors[field] = error;
                    isValid = false;
                    break;
                }
            }
        }

        return {isValid, errors};
    }
}
